import React, { useState } from "react"
import { useHistory, useLocation } from "react-router-dom"

import logo from "../../assets/logo.svg"
import { fbAuth } from "../../services/Firebase"
import { MdPersonOutline } from "react-icons/md"
import { RiSearch2Line, RiHeart2Line, RiLogoutCircleRLine } from "react-icons/ri"
import SearchComponent from "../SearchComponent"
import Toggler from "../Toggler"
import { useFavorite } from "../../contexts/FavoriteContext"

function MobileNav({ setShowPage }) { 
    const history = useHistory()
    const location = useLocation()
    const allowFavorite = useFavorite()
    const [ openModal, setOpenModal ] = useState( false )
    const [ openInput, setOpenInput  ] = useState( false )
    const [ animate, setAnimate ] = useState( false )
    let user = {}

    if (fbAuth.currentUser) {
        user = fbAuth.currentUser
    }

    const toggleModal = () => setOpenModal( !openModal )
    const toggleInput = () => {
        setOpenInput( !openInput )
        setAnimate( !animate )
    }
    
    const handleSignOut = () => {
        fbAuth.signOut().catch((error) => console.log(error))
        history.push( "/" )
    }

    const handleHomeRouting = () => {
        !location.pathname.includes( "/recipe" ) && history.push( "/" )
        location.pathname.includes( "/favorite/recipe" ) && history.push( "/" )
    }
    const handleFavoriteRouting = () => history.push( "/favorite" )

    return (
        <>
            <nav id="mobileNav">
                <img className="logo" src={logo} alt="Page Logo" onClick={handleHomeRouting} />
                <button className="navBtn" onClick={toggleInput}>
                    <RiSearch2Line title="Search Icon" size="22.5px" />
                </button>
                
                { allowFavorite 
                    &&  <button className="navBtn" onClick={handleFavoriteRouting}>
                        <RiHeart2Line title="Favorite Icon" size="22.5px" /> 
                    </button>
                }

                {
                    user.isAnonymous
                        ? <button onClick={toggleModal}><MdPersonOutline title="Person Icon" size="22.5px"/></button>
                        : <img src={user.photoURL} alt="User's Avatar" onClick={toggleModal} />
                }
                {
                    openModal
                    &&  <div id="mobileModal">
                        <Toggler />
                        <div onClick={handleSignOut}>
                            <RiLogoutCircleRLine size="22px" />
                        </div>
                    </div>
                }
                { openInput 
                    && <SearchComponent 
                        className={animate ? "searchModal animate" : "searchModal"} 
                        toggleInput={toggleInput}
                        setShowPage={setShowPage} /> }
            </nav>
        </>
    )
}

export default MobileNav
